import { Envelope } from "../geography.envelope";
import { GeoShape } from "./geography.shape";
import { GeoShapeType } from "./geography.shapes.interfaces";
export class GeoLine extends GeoShape {
    constructor(a, b) {
        super(GeoShapeType.Line);
        this._alice = a;
        this._bob = b;
    }
    get start() {
        return this._alice;
    }
    set start(v) {
        if (!this._alice.equals(v)) {
            this._alice = v;
            this.invalidateEnvelope();
        }
    }
    get end() {
        return this._bob;
    }
    set end(v) {
        if (!this._bob.equals(v)) {
            this._bob = v;
            this.invalidateEnvelope();
        }
    }
    _buildEnvelope() {
        return Envelope.FromPoints(this._alice, this._bob);
    }
}
//# sourceMappingURL=geography.line.js.map